<template>
  <div>
    <!-- PC端 -->
    <el-dialog v-if="!isMobile" class="questionaire-form questionaire-form-dialog" :visible.sync="visible" center append-to-body :title="questionaireName">
      <questionaireFormContent :type="type" @close="visible = false"></questionaireFormContent>
    </el-dialog>
    <!-- 移动端 -->
    <el-drawer v-else class="questionaire-form mobile-question-form-drawer" :title="questionaireName" :visible.sync="visible" direction="btt" size="100%" append-to-body center>
      <questionaireFormContent :type="type" @close="visible = false"></questionaireFormContent>
    </el-drawer>
  </div>
</template>
<script>
import questionaireFormContent from './components/questionaireFormContent.vue'

export default {
  data() {
    return {
      visible: false
    }
  },
  props: {
    type: {
      type: String,
      default: 'book'
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    questionaireName() {
      return this.$store.state.config[this.type + 'Obj'].questionContent.formName
    }
  },
  components: {
    questionaireFormContent
  }
}
</script>

<style lang="scss" scoped>
.questionaire-form {
  /deep/ .el-form {
    .el-form-item {
      width: 100%;
      display: flex;
      flex-direction: column;
      .el-form-item__label {
        text-align: left;
        padding: 0;
      }
      .el-form-item__content {
        margin-left: 0 !important;
        .questionaire-form-item {
          &.el-radio-group {
            line-height: inherit;
            .el-radio {
              width: 100%;
              .el-radio__label {
                white-space: pre-wrap;
              }
            }
          }
          .el-checkbox {
            width: 100%;
            line-height: normal;
            .el-checkbox__label {
              white-space: pre-wrap;
              display: inline;
            }
          }
        }
        .el-form-item__error--inline {
          display: block;
          margin-left: 0;
        }
      }
    }
    .el-scrollbar {
      height: 100%;
      .el-scrollbar__wrap {
        overflow-x: hidden !important;
        padding: 0 40px;
      }
      .is-horizontal {
        display: none;
      }
    }
  }
  /deep/ .questionaire-form-dialog-footer {
    text-align: center;
    margin-top: 35px;
    .questionaire-form-dialog-footer-button {
      width: 110px;
      height: 38px;
      color: #fff;
      line-height: 38px;
      display: inline-block;
      cursor: pointer;
      &.cancel {
        background-color: #999;
        margin-right: 28px;
      }
      &.confirm {
        background-color: #df5813;
      }
      &.disabled {
        background-color: #999;
      }
    }
  }
  &.questionaire-form-dialog {
    /deep/ .el-dialog {
      width: 640px;
      height: 500px;
      .el-dialog__title {
        text-align: center;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        padding: 0 40px;
        line-height: 40px;
        width: 100%;
      }
    }
    /deep/ .el-form {
      height: 330px;
      .el-form-item {
        width: 410px;
        margin: 0 auto;
      }
    }
  }
  &.mobile-question-form-drawer {
    /deep/ .el-drawer__header {
      background-color: #a9a9a9;
      padding: 0;
      height: 42px;
      line-height: 42px;
      color: #000;
      span {
        text-align: center;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        padding: 0 40px;
      }
      .el-drawer__close-btn {
        position: absolute;
        right: 10px;
        background-image: url('../../assets/imgs/close-quick-switch.png');
        background-size: 26px 26px;
        width: 26px;
        height: 26px;
        background-repeat: no-repeat;
        .el-dialog__close {
          display: none;
        }
      }
    }
    .el-drawer__body {
      overflow: hidden;
    }
    /deep/ .el-form {
      height: calc(100% - 80px);
    }
    /deep/ .questionaire-form-dialog-footer {
      margin: 20px 0;
    }
  }
}
</style>
